import { useState, useEffect, useCallback } from "react";
import { useGetCsrfQuery } from "../redux/api";

export const useLoadCsrf = () => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const { data, isLoading, isError, refetch } = useGetCsrfQuery(
        {  },
        { skip: !shouldFetch, refetchOnMountOrArgChange: true }
    );

    useEffect(() => {
        if (shouldFetch) {
            refetch();
        }
    }, [shouldFetch, refetch]);

    useEffect(() => {
        if (!isLoading && data && !isError) {
            setShouldFetch(false);
        } else if (!isLoading && isError) {
            setShouldFetch(false);
        }
    }, [data, isError, isLoading]);

    const loadCsrf = useCallback(() => {
        setShouldFetch(true);
    }, []);

    return { loadCsrf, isLoading, data, isError };
};